(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-cto-editorial]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const headings = [...root.querySelectorAll('[data-cto-article-body] h2, h2[id],section[id] > h2')].filter(heading => !heading.closest('[data-no-toc]'));
      if (headings.length > 2) {
        let toc = root.querySelector('[data-cto-toc]');
        if (!toc) {
          toc = document.createElement('details');
          const title = document.createElement('summary'), list = document.createElement('ol');
          toc.className = 'cto-article-toc'; title.textContent = root.dataset.tocLabel || 'Dans cet article';
          headings.forEach((heading, i) => {
            const target = heading.id ? heading : heading.parentElement.id ? heading.parentElement : heading;
            if (!target.id) target.id = 'lecture-' + i;
            const item = document.createElement('li'), link = document.createElement('a');
            link.href = '#' + target.id; link.textContent = heading.textContent; item.append(link); list.append(item);
          });
          toc.append(title, list); root.prepend(toc);
        }
        let reading = root.querySelector('.cto-editorial-content');
        if (!reading) {
          reading = document.createElement('div'); reading.className = 'cto-editorial-content';
          [...root.childNodes].filter(node => node !== toc).forEach(node => reading.append(node));
          root.append(reading);
        }
        const list = toc.querySelector('ol');
        root.classList.add('has-toc');
        toc.addEventListener('click', event => {
          const link = event.target.closest('a[href^="#"]');
          if (!link) return;
          const target = document.getElementById(decodeURIComponent(link.hash.slice(1)));
          if (!target) return;
          const heading = target.querySelector('h2, h3') || target;
          if (!heading.hasAttribute('tabindex')) heading.setAttribute('tabindex', '-1');
          requestAnimationFrame(() => {
            heading.focus({preventScroll: true});
            target.scrollIntoView({block: 'start', behavior: 'instant'});
          });
        });
        if ('IntersectionObserver' in window) {
          const links = [...list.querySelectorAll('a')];
          const observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) return;
              links.forEach(link => link.removeAttribute('aria-current'));
              links.find(link => link.hash === '#' + entry.target.id)?.setAttribute('aria-current', 'true');
            });
          }, {rootMargin: '-15% 0px -65% 0px'});
          headings.forEach(heading => observer.observe(heading.id ? heading : heading.parentElement));
        }
        const wide = matchMedia('(min-width: 1200px)');
        const resize = () => { toc.open = root.dataset.tocExpanded === 'true' || wide.matches; }; resize(); wide.addEventListener('change', resize);
      }
      root.querySelectorAll('table').forEach((table, i) => {
        let wrap = table.parentElement;
        if (!wrap.classList.contains('cto-table-scroll')) { wrap = document.createElement('div'); wrap.className = 'cto-table-scroll'; table.before(wrap); wrap.append(table); }
        const heading = table.closest('section')?.querySelector('h2');
        const label = table.caption?.textContent || heading?.textContent || (root.dataset.tableLabel || 'Tableau') + ' ' + (i + 1);
        if (table.rows[0]?.cells.length > 3) wrap.setAttribute('data-wide-table', '');
        wrap.tabIndex = 0; wrap.setAttribute('role', 'region'); wrap.setAttribute('aria-label', label + ' — ' + (root.dataset.scrollLabel || 'défilement horizontal'));
      });
    });
  };
  init(); document.addEventListener('shopify:section:load', event => init(event.target));
})();
